export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function assertisRecord(value) {
    if (!isRecord(value)) {
        throw TypeError(`Value is not of type Record<K, T>: ${value}`);
    }
}
//# sourceMappingURL=record.js.map